import * as content from "./content";
import { useRouter } from "next/router";
import AnalyticsSender from "../../helpers/analyticsSender";
import Footer from "./views/footer";

const FooterContainer = () => {
  const analyticsSender = new AnalyticsSender();
  const router = useRouter();

  return (
    <Footer
      url={router.pathname}
      links={content.links}
      year={content.year}
      sendClickEmail={analyticsSender.sendClickEmail}
      sendClickMenuTools={analyticsSender.sendClickMenuTools}
    />
  );
};

export default FooterContainer;
